// extracted by mini-css-extract-plugin
export default {"qrCode":"Login_qrCode__jkEe1"};